import { render, staticRenderFns } from "./Pochette.vue?vue&type=template&id=5be43510&scoped=true&"
import script from "./Pochette.vue?vue&type=script&lang=ts&"
export * from "./Pochette.vue?vue&type=script&lang=ts&"
import style0 from "./Pochette.vue?vue&type=style&index=0&id=5be43510&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be43510",
  null
  
)

export default component.exports